import { createFileRoute } from "@tanstack/react-router";
import { jobsInfiniteQuery } from "@/api/queries/jobs";
import type { JobType } from "@/api/types";
import { JobsPage } from "@/pages/jobs/JobsPage";

const JOB_TYPES: JobType[] = ["full-time", "contract", "commission", "rev-share"];

interface JobsSearch {
  q?: string;
  type?: JobType;
}

export const Route = createFileRoute("/_app/jobs")({
  validateSearch: (search): JobsSearch => ({
    q: typeof search.q === "string" && search.q ? search.q : undefined,
    type: typeof search.type === "string" && JOB_TYPES.includes(search.type as JobType)
      ? (search.type as JobType)
      : undefined,
  }),
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) =>
    context.queryClient.prefetchInfiniteQuery(jobsInfiniteQuery({ q: deps.q, type: deps.type })),
  component: JobsPage,
});
